import { render, staticRenderFns } from "./InvestorProfileForm.vue?vue&type=template&id=503a022e&scoped=true"
import script from "./InvestorProfileForm.vue?vue&type=script&lang=js"
export * from "./InvestorProfileForm.vue?vue&type=script&lang=js"
import style0 from "./InvestorProfileForm.vue?vue&type=style&index=0&id=503a022e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a022e",
  null
  
)

export default component.exports